import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Wrapper from "../components/Wrapper";
import { file, global, menu, input, shortFunction } from "../translate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPenToSquare, faTrashCan, faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import TextToVoice from "../components/TextToVoice";
import Yandex from "../components/Yandex";
import Cookies from "js-cookie";
import Api from "../Api";
import { useDispatch, useSelector } from "react-redux";
import {
    fileCreateRequest,
    fileDeleteLocal,
    fileDeleteRequest,
    fileRequest,
    fileUpdateRequest
} from "../store/actions/file";
import { REACT_APP_API_URL } from '../config';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Helmet } from "react-helmet";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import FewFilesUpload from "../components/FewFilesUpload";
import OpenAi from "../components/OpenAi";
import AudioPlayer from "../components/AudioPlayer";
import AudioPlayerBar from "../components/AudioPlayerBar";
import { Box, Typography, Paper, IconButton, TextField, InputAdornment, Tooltip, Button, Grid, Alert } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import SearchIcon from '@mui/icons-material/Search';
import { fileStyles } from "../helpers/style";

const { REACT_APP_SERVER } = process.env;
let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'

function Files(props) {
    const [form, setForm] = useState({
        name: '',
        file: {},
        size: 0
    })
    const [name, setName] = useState('')
    const [isName, setIsName] = useState(false)
    let link = REACT_APP_API_URL + ((REACT_APP_SERVER === 'Ucom' || REACT_APP_SERVER === 'V-office') ? '/rest' : '')
    const fileData = useSelector(state => state.file.fileData)
    const profileData = useSelector(state => state.users.userData)
    const [files, setFiles] = useState([])
    const [few, setFew] = useState(false)
    const [openAi, setOpenAi] = useState(false)
    const [editingFid, setEditingFid] = useState(null)
    const [editingName, setEditingName] = useState('')
    const handleChange = useCallback((name, ev) => {
        setForm((prev) => ({
            ...prev,
            [name]: ev
        }))
    }, [])
    const dispatch = useDispatch()
    const handleAdd = useCallback(async (ev) => {
        ev.preventDefault()
        if (!form.name) {
            toast.error("Please enter name!")
            return
        }
        await dispatch(fileCreateRequest({ ...form, size: form.file.size }))
    }, [form])
    const [interacted, setInteracted] = useState(false)
    const [trackIndexSet, setTrackIndex] = useState(0)
    const [sticky, setSticky] = useState(true)
    const trackList = useMemo(() => {
        return files.map(f => ({
            src: link + '/files/audio?file=' + f.fname + '&key=akNwNXN1U2k4bzdEQ09QU29KMUpYbXFiQTV5c3FmUm1MOUNheW5qWlYwOD0=',
            id: f.fname,
            name: f.name,
            type: ""
        }));
    }, [files, link]);

    const handleAudio = useCallback((r) => {
        setInteracted(true)
        const index = trackList.findIndex(s => s.id === r.fname);
        if (index !== -1) {
            setTrackIndex(index);
        } else {
            console.warn("Track not found for id:", r.fname);
        }
    }, [trackList])


    const handleDelete = useCallback(async (id) => {
        try {
            let text = +localStorage.getItem('atsLang') === 1 ? "Are you sure you want to delete?" :
                +localStorage.getItem('atsLang') === 2 ? "Вы уверены, что хотите судалить?" :
                    "Վստա՞հ եք, որ ցանկանում եք ջնջել";

            if (confirm(text) === true) {
                await dispatch(fileDeleteLocal(id))
                await dispatch(fileDeleteRequest(id))
            }
        } catch (e) {
            console.log(e)
        }
    }, [])

    const handleMusicChange = useCallback(async (f, value) => {
        if (value === 'after-rating') {
            await dispatch(fileUpdateRequest(f.id, 2, 'after-rating'))
        } else if (value === 'rate') {
            await dispatch(fileUpdateRequest(f.id, 1, 'rate'))
        } else if (value === 'musichold') {
            await dispatch(fileUpdateRequest(f.id, 1, 'musichold'))
        } else {
            await dispatch(fileUpdateRequest(f.id, 0, f.status))
        }
    }, [])


    const handleChangeName = useCallback(async (id) => {
        // await Api.download(id)
        await Api.fileChangeName(id, name)
        setFiles(prev => prev.map(f => {
            if (f.fname === id) {
                console.log(f, name)
                f.name = name
            }
            return f
        }))
        setIsName(false)
        // setName('')
        console.log(id, name)
    }, [name,])

    const [yandex, setYandex] = useState(false)
    const [text, setText] = useState(false)
    const [isPlaying, setIsPlaying] = useState(0);

    const showTableView = !!(Cookies.get('view') || localStorage.getItem('access_token_urs')) && Cookies.get('isAllowed') !== 'true';
    const langIndex = +localStorage.getItem('atsLang') || 1;
    const keySuffix = '&key=akNwNXN1U2k4bzdEQ09QU29KMUpYbXFiQTV5c3FmUm1MOUNheW5qWlYwOD0=';
    const audioRef = useRef(null);
    const [playingId, setPlayingId] = useState(null);
    const [currentTrack, setCurrentTrack] = useState(null);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const [volume, setVolume] = useState(1);
    const [speed, setSpeed] = useState(1);
    const speedRef = useRef(speed);
    useEffect(() => {
        speedRef.current = speed;
    }, [speed]);
    const [searchQuery, setSearchQuery] = useState('');

    const handleEditClick = useCallback((fileItem) => {
        const fid = fileItem?.fname || fileItem?.id || fileItem?.name;
        if (!fid) return;
        setEditingFid(fid);
        setEditingName((fileItem?.name || fileItem?.fname || fid || '').toString().trim());
    }, []);

    const handleSaveEdit = useCallback(async () => {
        if (editingFid == null || editingName.trim() === '') return;
        try {
            await Api.fileChangeName(editingFid, editingName.trim());
            setFiles((prev) =>
                prev.map((fileItem) => {
                    const fid = fileItem?.fname || fileItem?.id || fileItem?.name;
                    if (fid === editingFid) return { ...fileItem, name: editingName.trim() };
                    return fileItem;
                })
            );
            if (currentTrack && (currentTrack?.fname || currentTrack?.id || currentTrack?.name) === editingFid) {
                setCurrentTrack((t) => (t ? { ...t, name: editingName.trim() } : null));
            }
            setEditingFid(null);
            setEditingName('');
            toast.success(langIndex === 2 ? 'Название сохранено' : langIndex === 3 ? 'Անունը պահպանվել է' : 'Title saved');
        } catch (e) {
            toast.error(langIndex === 2 ? 'Не удалось сохранить' : langIndex === 3 ? 'Չհաջողվեց պահպանել' : 'Failed to save');
        }
    }, [editingFid, editingName, currentTrack, langIndex]);

    const handleCancelEdit = useCallback(() => {
        setEditingFid(null);
        setEditingName('');
    }, []);

    useEffect(() => {
        (async () => {
            await dispatch(fileRequest())
        })()
    }, [])
    useEffect(() => {
        fileData.map(f => {
            if (f.mhold) {
                f.status = 'musichold'
            } else if (f.rate === 1) {
                f.status = 'rate'
            } else if (f.rate === 2) {
                f.status = 'after-rating'
            } else {
                f.status = ''
            }

            return f
        })
        setFiles(fileData)
    }, [fileData])
    const handleSelectName = useCallback(async (id, n, type) => {
        if (type === 'select') {
            setIsName(id)
            setName(n)
        } else {
            await handleChangeName(id)
        }
    }, [name])
    const handleAudioEnd = () => {
        setIsPlaying(0);
    };

    const getAudioSrc = useCallback((f) => {
        const fid = f?.fname || f?.id;
        return fid ? `${link}/files/audio?file=${fid}${keySuffix}` : null;
    }, [link]);
    const formatTime = useCallback((s) => {
        if (!s || !Number.isFinite(s)) return '0:00';
        const m = Math.floor(s / 60);
        const sec = Math.floor(s % 60);
        return `${m}:${sec < 10 ? '0' : ''}${sec}`;
    }, []);
    const formatFileSize = useCallback((bytes) => {
        if (bytes == null || bytes === 0) return '—';
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    }, []);
    const formatFileDate = useCallback((value) => {
        if (!value) return '—';
        const d = value instanceof Date ? value : new Date(typeof value === 'number' ? value : value);
        if (Number.isNaN(d.getTime())) return '—';
        return d.toLocaleString();
    }, []);

    const stopAudioCard = useCallback(() => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
        setPlayingId(null);
        setCurrentTime(0);
    }, []);

    const handlePlayFile = useCallback((file) => {
        const fid = file?.fname || file?.id;
        const src = getAudioSrc(file);
        if (!fid || !src) return;
        const el = audioRef.current;
        if (!el) return;
        if (playingId === fid) {
            el.pause();
            setPlayingId(null);
            return;
        }
        try {
            el.src = src;
            el.load();
            el.playbackRate = speedRef.current;
            setCurrentTrack(file);
            setCurrentTime(0);
            setDuration(0);
            setPlayingId(fid);
            el.play().catch(() => stopAudioCard());
        } catch (e) {
            stopAudioCard();
        }
    }, [playingId, getAudioSrc, stopAudioCard]);

    const handlePlayerPlayPause = useCallback(() => {
        const el = audioRef.current;
        if (!el || !currentTrack) return;
        if (playingId) {
            el.pause();
            setPlayingId(null);
        } else {
            const src = getAudioSrc(currentTrack);
            if (src) {
                if (!el.src) {
                    el.src = src;
                    el.load();
                }
                el.playbackRate = speedRef.current;
                setPlayingId(currentTrack?.fname || currentTrack?.id);
                el.play().catch(() => setPlayingId(null));
            }
        }
    }, [currentTrack, playingId, getAudioSrc]);

    const handleSeek = useCallback((_, value) => {
        const el = audioRef.current;
        if (!el || !duration) return;
        const t = (Number(value) / 100) * duration;
        el.currentTime = t;
        setCurrentTime(t);
    }, [duration]);

    const handleDownloadFile = useCallback((file) => {
        const fid = file?.fname || file?.id;
        if (!fid) return;
        const url = `${link}/files/download?uid=${fid}`;
        const a = document.createElement('a');
        a.href = url;
        a.download = (file.name || fid) + '.mp3';
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        a.remove();
    }, [link]);

    useEffect(() => {
        if (showTableView) return;
        const el = audioRef.current;
        if (!el) return;
        const onLoadedMetadata = () => {
            el.playbackRate = speedRef.current;
            setDuration(el.duration);
        };
        const onTimeUpdate = () => setCurrentTime(el.currentTime);
        const onEnded = () => { setPlayingId(null); setCurrentTime(0); };
        el.addEventListener('loadedmetadata', onLoadedMetadata);
        el.addEventListener('timeupdate', onTimeUpdate);
        el.addEventListener('ended', onEnded);
        return () => {
            el.removeEventListener('loadedmetadata', onLoadedMetadata);
            el.removeEventListener('timeupdate', onTimeUpdate);
            el.removeEventListener('ended', onEnded);
        };
    }, [showTableView]);

    useEffect(() => {
        if (showTableView) return;
        const el = audioRef.current;
        if (el) el.volume = volume;
    }, [volume, showTableView]);

    useEffect(() => {
        if (showTableView) return;
        const el = audioRef.current;
        if (!el) return;
        el.playbackRate = speed;
    }, [speed, showTableView, currentTrack?.fname, currentTrack?.id, playingId]);

    const filteredFilesCard = (searchQuery.trim()
        ? files.filter((f) => {
            const label = (f?.name || f?.fname || f?.id || '').toString().toLowerCase();
            return label.includes(searchQuery.trim().toLowerCase());
        })
        : [...files]
    ).sort((a, b) => (Number(b?.id) ?? 0) - (Number(a?.id) ?? 0));
    const progress = duration > 0 ? (currentTime / duration) * 100 : 0;
    const playerLabel = currentTrack ? (currentTrack?.name || currentTrack?.fname || currentTrack?.id) : (langIndex === 2 ? 'Нет трека' : langIndex === 3 ? 'Երգ չկա' : 'No track');
    const currentTrackFid = currentTrack ? (currentTrack?.fname || currentTrack?.id) : null;
    const currentIndex = currentTrackFid != null ? filteredFilesCard.findIndex((f) => (f?.fname || f?.id) === currentTrackFid) : -1;
    const canGoPrev = currentIndex > 0;
    const canGoNext = currentIndex >= 0 && currentIndex < filteredFilesCard.length - 1;
    const handlePrev = useCallback(() => {
        if (!canGoPrev) return;
        const prevFile = filteredFilesCard[currentIndex - 1];
        if (prevFile) handlePlayFile(prevFile);
    }, [canGoPrev, currentIndex, filteredFilesCard, handlePlayFile]);
    const handleNext = useCallback(() => {
        if (!canGoNext) return;
        const nextFile = filteredFilesCard[currentIndex + 1];
        if (nextFile) handlePlayFile(nextFile);
    }, [canGoNext, currentIndex, filteredFilesCard, handlePlayFile]);

    return (
        <>
            <Helmet>
                <title>
                    {menu?.file[+localStorage.getItem('atsLang') || 1]}
                </title>
            </Helmet>
            <Wrapper>
                <div className="tableParent">
                    <Paper sx={{ p: 3 }}>
                        <Box sx={fileStyles.headerBox}>
                            <Typography variant="h5" sx={fileStyles.title}>
                                {file.file[langIndex]}
                            </Typography>
                        </Box>

                        <Alert
                            icon={<InfoIcon />}
                            severity="success"
                            sx={
                                REACT_APP_SERVER !== 'ATS'
                                    ? { mb: 3 }
                                    : {
                                        mb: 3,
                                        border: `1px solid ${color}`,
                                        backgroundColor: `${color}10`,
                                        '& .MuiAlert-icon': { color },
                                    }
                            }
                        >
                            <Typography variant="body2">
                                {file.name1?.[langIndex] || (langIndex === 2 ? 'Укажите название и выберите файл для загрузки.' : langIndex === 3 ? 'Նշեք անունը և ընտրեք ֆայլը:' : 'Enter a name and choose a file to upload.')}
                                {langIndex === 2 ? ' Загружаемый файл не должен превышать 5 МБ.' : langIndex === 3 ? ' Բեռնվող ֆայլը չպետք է գերազանցի 5 MB-ը.' : ' The uploaded file must not exceed 5 MB.'}
                            </Typography>
                        </Alert>

                        <Paper component="form" onSubmit={handleAdd} sx={fileStyles.formPaper(color)}>
                            <Typography variant="h6" sx={fileStyles.formTitle}>
                                {file.file[langIndex]}
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label={file.name[langIndex]}
                                        value={form.name}
                                        onChange={(ev) => handleChange('name', ev.target.value)}
                                        variant="outlined"
                                        sx={fileStyles.inputField(color)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Button
                                        component="label"
                                        variant="outlined"
                                        fullWidth
                                        sx={fileStyles.fileButton(color)}
                                    >
                                        {form.file?.name || file.choose[langIndex]}
                                        <input
                                            type="file"
                                            hidden
                                            onChange={(ev) => handleChange('file', ev.target.files?.[0] || {})}
                                        />
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            sx={fileStyles.addButton(color)}
                                        >
                                            {global.add[langIndex]}
                                        </Button>
                                        {Cookies.get('key') && Cookies.get('original') ? (
                                            <Button
                                                variant="outlined"
                                                onClick={() => setFew(true)}
                                                sx={fileStyles.addFewButton(color)}
                                            >
                                                {global.addFew[langIndex]}
                                            </Button>
                                        ) : null}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Paper>
                </div>
                {showTableView ? (
                    <>
                {trackList.length ? (
                    <div style={fileStyles.stickyPlayer(sticky)}>
                        <AudioPlayer
                            setSticky={setSticky}
                            loading={false}
                            handleText={() => null}
                            interacted={interacted}
                            track={trackList}
                            trackIndexSet={trackIndexSet}
                            setTrackIndex={setTrackIndex}
                        />
                    </div>
                ) : null}

                <div className="tableParent file" style={fileStyles.tableParent}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h3>{file.file[+localStorage.getItem('atsLang') || 1]}</h3>
                    </div>
                    <table cellPadding="0" cellSpacing="0">
                        <thead>
                            <tr>
                                <th />
                                <th>{file.name[+localStorage.getItem('atsLang') || 1]}</th>
                                <th>{file.fileUpload[+localStorage.getItem('atsLang') || 1]}</th>
                                <th>{file.volume[+localStorage.getItem('atsLang') || 1]}</th>
                                <th>{file.code[+localStorage.getItem('atsLang') || 1]}</th>
                                <th>
                                    <p>{file.hold1[+localStorage.getItem('atsLang') || 1]}</p> :

                                </th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {files.length ? files.map(f => {
                                return (
                                    <tr key={f.fname}>
                                        <td><CheckCircleIcon style={{ color: color }} /></td>
                                        {isName === f.fname ?
                                            <td>
                                                <span className='d-flex align-items-center justify-content-between'>
                                                    <input className="ok" type="text" value={name} onChange={(ev) => setName(ev.target.value)} />
                                                    <FontAwesomeIcon style={{ fontSize: 18, marginLeft: 10, cursor: 'pointer', color }} onClick={() => handleSelectName(f.fname, f.name, 'change')} icon={faSquareCheck} />
                                                </span>

                                            </td> :
                                            <td><span className='d-flex align-items-center justify-content-between'>
                                                <a style={{ textDecoration: 'revert', color: 'blue' }} target="_blank"
                                                    href={link + '/files/download?uid=' + f.fname}
                                                    download={f.fname + '.mp3'}>{f.name}</a> <FontAwesomeIcon style={{ fontSize: 18, marginLeft: 10, cursor: 'pointer', color }} onClick={() => handleSelectName(f.fname, f.name, 'select')} icon={faPen} />
                                            </span></td>}

                                        <td>{new Date(f.date).toLocaleString()}</td>
                                        <td>{Math.round(+f.size / (1024 * 1024) * 1000) / 1000} mb</td>
                                        <td>{f.fname}</td>
                                        <td>

                                            <select
                                                style={{ height: 40, border: '1px solid #ccc', outline: 'none' }}
                                                value={f.status}
                                                onChange={(ev) => handleMusicChange(f, ev.target.value)}
                                            >
                                                <option value="">Select</option>
                                                <option value="musichold">MusicHold</option>
                                                <option value="rate">Rate</option>
                                                <option value="after-rating">After-rating Feedback</option>
                                            </select>

                                        </td>
                                        <td style={{ cursor: 'pointer', color: 'red' }} onClick={() => handleDelete(f.id)}>
                                            <FontAwesomeIcon icon={faTrashCan} /></td>

                                        <td style={{ cursor: 'pointer', color }} >
                                            {isPlaying === f.fname ? <StopCircleIcon onClick={() => handleAudio(f)} /> : <PlayCircleIcon
                                                onClick={() =>
                                                    handleAudio(f)}
                                                style={{ color: color }} />}
                                        </td>
                                    </tr>
                                )
                            }) : null}

                        </tbody>

                    </table>
                </div>
                    </>
                ) : (
                    <>
                        <audio ref={audioRef} style={{ display: 'none' }} />
                        <AudioPlayerBar
                            onPrev={handlePrev}
                            onNext={handleNext}
                            onPlayPause={handlePlayerPlayPause}
                            onSeek={handleSeek}
                            onDownload={handleDownloadFile}
                            currentTrack={currentTrack}
                            playingId={playingId}
                            progress={progress}
                            duration={duration}
                            currentTime={currentTime}
                            volume={volume}
                            onVolumeChange={setVolume}
                            playerLabel={playerLabel}
                            canGoPrev={canGoPrev}
                            canGoNext={canGoNext}
                            formatTime={formatTime}
                            formatFileSize={formatFileSize}
                            formatFileDate={formatFileDate}
                            langIndex={langIndex}
                            paperSx={fileStyles.playerPaper}
                            speed={speed}
                            onSpeedChange={setSpeed}
                        />

                        <div className="tableParent" style={{ marginTop: '10px' }}>
                            <Paper sx={{ p: 3, pb: 5 }}>
                                <Typography variant="h6" sx={fileStyles.fileListTitle}>
                                    {file.file[langIndex]}
                                </Typography>
                                {files.length > 0 && (
                                    <TextField
                                        fullWidth
                                        size="small"
                                        placeholder={input?.search?.[langIndex] || 'Search'}
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        sx={{
                                        ...fileStyles.searchField,
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': { borderColor: color },
                                            '&:hover fieldset': { borderColor: color },
                                            '&.Mui-focused fieldset': { borderColor: color },
                                        },
                                    }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon sx={{ ...fileStyles.searchIcon, color }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                )}
                                {filteredFilesCard.length > 0 ? (
                                    <Box sx={fileStyles.cardGrid}>
                                        {filteredFilesCard.map((f) => {
                                            const fid = f?.fname || f?.id || f?.name;
                                            const label = f?.name || f?.fname || fid;
                                            return (
                                                <Paper
                                                    key={f.fname ?? f.id}
                                                    elevation={0}
                                                    sx={{ ...fileStyles.fileCard, '&:hover': { borderColor: color, boxShadow: `0 6px 20px ${color}59` } }}
                                                >
                                                    {editingFid === fid ? (
                                                        <>
                                                            <TextField
                                                                size="small"
                                                                value={editingName}
                                                                onChange={(e) => setEditingName(e.target.value)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') handleSaveEdit();
                                                                    if (e.key === 'Escape') handleCancelEdit();
                                                                }}
                                                                autoFocus
                                                                sx={fileStyles.editTextField(color)}
                                                            />
                                                            <Button
                                                                size="small"
                                                                sx={fileStyles.saveButton(color)}
                                                                onClick={handleSaveEdit}
                                                            >
                                                                {shortFunction.operator_save?.[langIndex] || 'Save'}
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                sx={fileStyles.cancelButton}
                                                                onClick={handleCancelEdit}
                                                            >
                                                                {shortFunction.operator_close?.[langIndex] || 'Cancel'}
                                                            </Button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Typography variant="body2" sx={fileStyles.labelText}>
                                                                {label}
                                                            </Typography>
                                                            <Button
                                                                variant="text"
                                                                size="small"
                                                                sx={fileStyles.playButton(color)}
                                                                onClick={() => handlePlayFile(f)}
                                                            >
                                                                {playingId === fid ? '■' : '▶'}
                                                            </Button>
                                                            <Tooltip title={langIndex === 2 ? 'Редактировать' : langIndex === 3 ? 'Խմբագրել' : 'Edit'}>
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => handleEditClick(f)}
                                                                    sx={{ ...fileStyles.editIconButton, color, '&:hover': { backgroundColor: `${color}15` } }}
                                                                    aria-label="Edit"
                                                                >
                                                                    <FontAwesomeIcon icon={faPenToSquare} />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <IconButton
                                                                size="small"
                                                                sx={fileStyles.deleteIconButton}
                                                                onClick={() => handleDelete(f.id)}
                                                                aria-label="Delete"
                                                            >
                                                                <FontAwesomeIcon icon={faTrashCan} style={{ fontSize: 14 }} />
                                                            </IconButton>
                                                        </>
                                                    )}
                                                </Paper>
                                            );
                                        })}
                                    </Box>
                                ) : (
                                    <Typography variant="body2" color="text.secondary">
                                        {files.length > 0
                                            ? (langIndex === 2 ? 'Ничего не найдено' : langIndex === 3 ? 'Ոչինչ չի գտնվել' : 'No files match your search.')
                                            : (langIndex === 2 ? 'Нет файлов' : langIndex === 3 ? 'Ֆայլեր չկան' : 'No files yet.')}
                                    </Typography>
                                )}
                            </Paper>
                        </div>
                    </>
                )}
                {few ? <FewFilesUpload open={few} setOpen={setFew} /> : null}
                {text ? <TextToVoice open={text} setOpen={setText} /> : null}
                {openAi ? <OpenAi open={openAi} setOpen={setOpenAi} /> : null}
                {yandex ? <Yandex open={yandex} setOpen={setYandex} /> : null}
            </Wrapper>

        </>
    );
}

export default Files;
